var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('photo-variant-assign-panel',{attrs:{"product-id":_vm.id,"photo":_vm.assignPhoto},on:{"saved":_vm.onAssigned},model:{value:(_vm.assignOpen),callback:function ($$v) {_vm.assignOpen=$$v},expression:"assignOpen"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }